import React, {createContext, useContext, useState, useEffect} from 'react';

interface DeviceInfoContextType {
  deviceInfo: string;
}

const DeviceInfoContext = createContext<DeviceInfoContextType | undefined>(undefined);

export const DeviceInfoProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
  const [deviceInfo, setDeviceInfo] = useState<string>('');

  useEffect(() => {
    const getDeviceInfo = () => {
      const info = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        vendor: navigator.vendor,
        appVersion: '1.0.0'
      };

      setDeviceInfo(JSON.stringify(info));
    };

    getDeviceInfo();
  }, []);

  return (
    <DeviceInfoContext.Provider value={{deviceInfo}}>
      {children}
    </DeviceInfoContext.Provider>
  );
};

export const useDeviceInfo = () => {
  const context = useContext(DeviceInfoContext);
  if (context === undefined) {
    throw new Error('useDeviceInfo must be used within a DeviceInfoProvider');
  }
  return context;
};
